import {gatewayInstance} from "../axiosInstance";
import {SERVICE_ENDPOINT} from "../const";

export const acknowledgeNotification = async (data) => {
    return await gatewayInstance.post(
        `${SERVICE_ENDPOINT.TRANSPORT}/notification/confirm`,
        data,
    );
};